import React from 'react'
import {
  ClickCeaseCreditCardBottom,
  ClickCeaseCreditCardNumber,
  ClickCeaseCreditCardProperty,
  ClickCeaseCreditCardPropertyText,
  ClickCeaseCreditCardPropertyTitle,
  ClickCeaseCreditCardStyles,
} from 'Features/accountSettings/components/Billing/ClickCeaeCreditCard/ClickCeaseCreditCard.styles'
import { CQEssentialsLogo } from 'Assets/icons/CQEssentialsLogo'
import { useTranslation } from 'react-i18next'

type ClickCeaseCreditCardProps = {
  cardNumber: string
  validThru: string
}

export const ClickCeaseCreditCard = ({ cardNumber, validThru }: ClickCeaseCreditCardProps) => {
  const { t } = useTranslation('general')

  return (
    <ClickCeaseCreditCardStyles>
      <CQEssentialsLogo width={'180px'} />
      <ClickCeaseCreditCardNumber>{cardNumber}</ClickCeaseCreditCardNumber>
      <ClickCeaseCreditCardBottom>
        <ClickCeaseCreditCardProperty>
          <ClickCeaseCreditCardPropertyTitle>
            {t('credit_card.expiry_date')?.toUpperCase()}
          </ClickCeaseCreditCardPropertyTitle>
          <ClickCeaseCreditCardPropertyText>{validThru}</ClickCeaseCreditCardPropertyText>
        </ClickCeaseCreditCardProperty>
      </ClickCeaseCreditCardBottom>
    </ClickCeaseCreditCardStyles>
  )
}
